import React, { useState, useEffect } from "react";
import Variants from "../components/skeletons/ProductSkeleton";
import SharedTable from "../components/shared/SharedTable";
import SharedDataAddButton from "../components/shared/SharedAddButton";
import CustomizedSnackbars from "../components/shared/SuccessPopup";
import backgroundImage from "../assets/background2.png";
import SharedPopupModal from "../components/shared/SharedPopupModal";
import { useNavigate } from "react-router-dom";
import AddForm from "../components/AddCampaigncreateForm";
import Form from "../components/CreateCampaignPopupForm";
import { Button } from "@mui/material";
import FullScreenDialog from "../components/shared/fullScreenDialogue";


const CreateCampaign = () => {
  const navigate = useNavigate();


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openFullScreen, setOpenFullScreen] = React.useState(false);

  const handleClickOpen = () => {
    setOpenFullScreen(true);
  };

  const [formData, setFormData] = React.useState({
    name:"",
    _id:"",
    products:[],
    isActive:''
  });

  const columns = [
    {
      field: "name",
      headerName: "Campaign Name",
      width: 340,
      headerClassName:
        "text-lg text-bold font-sans font-bold bg-skin-table-header text-skin-inverted",
    },
    {
        field: "_id",
        headerName: "Update Campaign",
        width: 270,
        headerClassName:
          "text-lg text-bold font-sans font-bold text-skin-inverted bg-skin-table-header",
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <strong>
            <Button
              variant="contained"
              sx={{
                borderRadius: "20px",
                backgroundColor: "var(--color-button-generate)",
                "&:hover": {
                  backgroundColor: "var(--color-button-generate-hover)",
                },
              }}
              tabIndex={params.hasFocus ? 0 : -1}
              onClick={() => handleClickOpen()}
            >
              UPDATE
            </Button>
          </strong>
        ),
      },
      {
        field: "isActive",
        headerName: "Active",
        width: 270,
        headerClassName:
          "text-lg text-bold font-sans font-bold text-skin-inverted bg-skin-table-header",
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <strong>
            <div>{params.value?'true':'false'}</div>
          </strong>
        ),
      }
    // { field: 'division', headerName: 'Division', width: 250,headerClassName:'text-lg text-bold font-sans font-bold bg-skin-table-header text-skin-inverted'},
   
  ];

  //data should be fetched from the server
  // const [data, setData] = useState(null);

  const [fetchSuccess, setFetchSuccess] = useState(false);
  const [fetchFailure, setFetchFailure] = useState(false);

  const [pageState, setpageState] = useState({
    data: null,
    page: 1,
    pageSize: 5,
    total: 1,
  });



  // const fetchCampaignData = async (id) => {
  //   const userDetails = JSON.parse(localStorage.getItem("token"));
  //   let token = userDetails ? userDetails.result.token : null;

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${id}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response.status === 401) {
  //       alert("Session Expired, Please login again");
  //       localStorage.removeItem("token");
  //       navigate("/login");
  //     }
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch data");
  //     }
  //     const jsonData = await response.json();
  //     console.log(jsonData)
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };




  const fetchData = async () => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/campaigns?page=${pageState.page}&limit=${pageState.pageSize}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/login");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const jsonData = await response.json();
      // console.log(jsonData)
      // setData(jsonData);
      setpageState((prev) => ({
        ...prev,
        data: jsonData.data,
        total: jsonData.totalpages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageState.page, pageState.pageSize]); // Empty dependency array means this effect runs once on component mount

  const handleFetchSuccess = () => {
    setFetchSuccess(true);
    // You can add additional logic here if needed
  };

  const handleFetchFailure = () => {
    setFetchFailure(true);
    // You can add additional logic here if needed
  };

 

  const componentStyle = {
    height: 400,
    
    // Add other styles as needed
  };

  const popupModalProps = {
    fetchData,
    handleFetchFailure,
    handleFetchSuccess,
    formData,
  };

  return (
    <div className=" h-full w-full flex flex-col p-7">
      {/* <div className='flex flex-col flex-wrap p-4 pt-3 bg-green-300 rounded-lg overflow-scroll'> */}
      {pageState.data ? (
        <div
          className="bg-skin-wrap-fill p-5 pb-7 flex flex-col gap-4 rounded-2xl drop-shadow-2xl mt-1 bg-cover bg-center h-100vh"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <h1 className="text-4xl font-bold font-sans text-skin-base">
            CREATE CAMPAIGN
          </h1>
          <div className="flex justify-between items-center">
            {/* <div className='text-skin-base'> search box with down menuD</div> */}
            <div className="text-skin-base"></div>

            <SharedDataAddButton
              Component={AddForm}
              popupModalProps={popupModalProps}
            />

            {/* <SharedDataAddButton fetchData={fetchData} Component={PopupAddModel} ComponentProps = {ComponentProps}/> */}
          </div>
          <div>
            <SharedPopupModal
              open={open}
              handleClose={handleClose}
              ChildComponent={Form}
              popupModalProps={popupModalProps}
            />
            {
              openFullScreen && <FullScreenDialog open={openFullScreen} setOpen={setOpenFullScreen} fetchData={fetchData} formData={formData} handleFetchFailure={handleFetchFailure} handleFetchSuccess={handleFetchSuccess} />
            }
            {/* <FullScreenDialog open={openFullScreen} setOpen={setOpenFullScreen} formData={formData} /> */}
            {/* <BasicModal open = {open} handleClose = {handleClose} formData = {formData} fetchData = {fetchData} handleFetchSuccess={handleFetchSuccess} handleFetchFailure={handleFetchFailure}/> */}
            <SharedTable
              handleOpen={handleOpen}
              setFormData={setFormData}
              pageState={pageState}
              setpageState={setpageState}
              columns={columns}
              componentStyle={componentStyle}
            />
          </div>
        </div>
      ) : (
        <Variants />
      )}
      {fetchSuccess && (
        <CustomizedSnackbars
          severity="success"
          message="Operation Successfull !"
          open={fetchSuccess}
          handleClose={() => setFetchSuccess(false)}
        />
      )}

      {fetchFailure && (
        <CustomizedSnackbars
          severity="error"
          message="Operation Failed !"
          open={fetchFailure}
          handleClose={() => setFetchFailure(false)}
        />
      )}
    </div>
  );
};

export default CreateCampaign;
